import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Card } from '../../../base/card/Card.js';
import styles from './Skeleton.module.scss.js';

var Skeleton = function () { return (jsxs(Card, __assign({ "data-testid": "skeleton" }, { children: [jsx("div", { className: styles.title }), jsx("div", { className: styles.subtitle }), jsx(Card.Separator, {}), jsx("div", { className: styles.productName }), jsx(Card.Separator, {}), jsx("div", { className: styles.frequency }), jsx("div", { className: styles.button })] }))); };

export { Skeleton };
